import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  public beforePrintCalled$: Subject<PrintContext> = new Subject<PrintContext>();
  public afterPrintCalled$: Subject<PrintContext> = new Subject<PrintContext>();

  public print(printContext?: PrintContext): void {
    if (window) {
      this.beforePrintCalled$.next(printContext);
      setTimeout(() => {
        window.print();
        this.afterPrintCalled$.next(printContext);
      }, 10);
    }
  }
}

export interface PrintContext {
  properties: { [key: string]: string };
}
